import { defineMessages } from 'react-intl'

export const homeMessages = defineMessages({
  activity: {
    defaultMessage: 'Activity',
    description: 'home card title',
  },
  allCaughtUp: {
    defaultMessage: "You're all caught up",
    description: 'home queue empty state',
  },
  assignmentsAutoManualSplit: {
    defaultMessage: '{total} total · {auto} auto-assigned · {manual} manual',
    description: 'home assignments summary line',
  },
  assignmentsThisWeek: {
    defaultMessage: 'Assignments this week',
    description: 'home card title',
  },
  cardLoadFailed: {
    defaultMessage: "Couldn't load this card",
    description: 'home card error state',
  },
  closedThisWeek: {
    defaultMessage: 'Closed this week',
    description: 'home stat tile label',
  },
  customersFallbackDescription: {
    defaultMessage: 'Browse and search the customer directory',
    description: 'home empty-audience fallback card description',
  },
  customersFallbackTitle: {
    defaultMessage: 'Customers',
    description: 'home empty-audience fallback card title',
  },
  dueToday: {
    defaultMessage: 'Due today',
    description: 'home stat tile label — reminders due today',
  },
  feeUnpaid: {
    defaultMessage: 'Fee unpaid',
    description: 'home stat tile label',
  },
  fullReport: {
    defaultMessage: 'Full report',
    description: 'home card action link',
  },
  goingStale: {
    defaultMessage: 'Going stale',
    description: 'home stat tile label',
  },
  greetingAfternoon: {
    defaultMessage: 'Good afternoon, {name}',
    description: 'home header greeting',
  },
  greetingEvening: {
    defaultMessage: 'Good evening, {name}',
    description: 'home header greeting',
  },
  greetingMorning: {
    defaultMessage: 'Good morning, {name}',
    description: 'home header greeting',
  },
  idleFor: {
    defaultMessage: 'idle {duration}',
    description: 'home operator activity idle pill',
  },
  lastActive: {
    defaultMessage: 'active {time}',
    description: 'home operator activity row',
  },
  messagesCard: {
    defaultMessage: 'Messages',
    description: 'home card title',
  },
  myOpenCases: {
    defaultMessage: 'My open cases',
    description: 'home stat tile label',
  },
  myOpenTickets: {
    defaultMessage: 'My open tickets',
    description: 'home stat tile label',
  },
  needsAttention: {
    defaultMessage: 'Needs attention',
    description: 'home messaging row',
  },
  needsFirstContact: {
    defaultMessage: 'Needs first contact',
    description: 'home card title',
  },
  neverContacted: {
    defaultMessage: 'Never contacted',
    description: 'home stat tile label',
  },
  newLeadsLastDays: {
    defaultMessage: 'New leads, last 7 days',
    description: 'home card title',
  },
  newThisWeek: {
    defaultMessage: 'New this week',
    description: 'home stat tile label',
  },
  noSettlement: {
    defaultMessage: 'No settlement',
    description: 'home ticket row pill: no adjusted debt recorded',
  },
  nothingWaiting: {
    defaultMessage: 'Nothing waiting — nice.',
    description: 'home card empty state',
  },
  oldestOpenTickets: {
    defaultMessage: 'Oldest open tickets',
    description: 'home card title',
  },
  openCasesAll: {
    defaultMessage: 'Open cases',
    description: 'home stat tile label',
  },
  openInbox: {
    defaultMessage: 'Open inbox',
    description: 'home card action link',
  },
  operatorActivityToday: {
    defaultMessage: 'Operator activity today',
    description: 'home card title',
  },
  owesReply: {
    defaultMessage: 'You owe a reply',
    description: 'home messaging row',
  },
  pendingAging: {
    defaultMessage: '{count} over 1 day',
    description: 'home pending tile aging pill',
  },
  pendingAssignment: {
    defaultMessage: 'Pending assignment',
    description: 'home stat tile label',
  },
  pipelineByStage: {
    defaultMessage: 'Pipeline by stage',
    description: 'home card title',
  },
  remindersNoneDue: {
    defaultMessage: 'Nothing due today',
    description: 'home reminders queue empty state',
  },
  remindersOverdue: {
    defaultMessage: 'Overdue',
    description: 'home reminders queue — section heading',
  },
  remindersQueue: {
    defaultMessage: 'Reminders',
    description: 'home card title — my reminders due today',
  },
  remindersToday: {
    defaultMessage: 'Today',
    description: 'home reminders queue — section heading',
  },
  stuckCases: {
    defaultMessage: 'Stuck over 5 days',
    description: 'home stat tile label: open, aged, no successful contact',
  },
  subtitleFirstContact: {
    defaultMessage:
      '{count, plural, one {# case needs a first contact} other {# cases need a first contact}}',
    description: 'home header subtitle part',
  },
  subtitlePendingAssignment: {
    defaultMessage:
      '{count, plural, one {# case pending assignment} other {# cases pending assignment}}',
    description: 'home header subtitle part',
  },
  subtitleTicketsFirstContact: {
    defaultMessage:
      '{count, plural, one {# ticket not yet contacted} other {# tickets not yet contacted}}',
    description: 'home header subtitle part',
  },
  teamLoadCard: {
    defaultMessage: 'Team load',
    description: 'home card title: per-member open case load',
  },
  teamOpenCases: {
    defaultMessage: 'Team open cases',
    description: 'home stat tile label',
  },
  teamOpenTickets: {
    defaultMessage: 'Team open tickets',
    description: 'home stat tile label',
  },
  teamUncontacted: {
    defaultMessage: 'Team uncontacted',
    description: 'home stat tile label',
  },
  ticketsNotContacted: {
    defaultMessage: 'Not yet contacted',
    description: 'home stat tile label',
  },
  triageQueue: {
    defaultMessage: 'Triage queue',
    description: 'home stat tile label: unassigned conversations',
  },
  uncontactedCount: {
    defaultMessage: '{count} uncontacted',
    description: 'home workload row pill',
  },
  unread: {
    defaultMessage: 'Unread',
    description: 'home messaging row',
  },
  viewAll: {
    defaultMessage: 'View all',
    description: 'home card action link',
  },
  windowsClosing: {
    defaultMessage: 'Windows closing (24h)',
    description: 'home messaging row: WhatsApp reply windows about to expire',
  },
  workloadCard: {
    defaultMessage: 'Workload',
    description: 'home card title',
  },
})
